import {useEffect, useRef} from "react";

import {RequestState} from "@pg-mono/hooks";

import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {IPropertyGallery} from "../../../property/types/IPropertyGallery";
import {IOfferGallery} from "../../detail/types/IOfferGallery";
import {IConstructionGalleryResponse} from "../../types/ConstructionGallery";
import {IOfferDetail} from "../../types/IOfferDetail";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";
import {getOpenGalleryAmplitudePayload} from "./get_open_gallery_amplitude_payload";
import {trackAmplitudeOpenGallery} from "./track_amplitude_open_gallery";

interface UseTrackAmplitudeOpenGalleryParams {
    isOpen: boolean;
    modalState: OfferModalActiveTab | null;
    location?: string;
    galleryFetchState: RequestState;
    propertyGalleryFetchState: RequestState;
    constructionFetchState: RequestState;
    offer: IPropertyDetailOffer | IOfferDetail;
    property?: IPropertyDetail;
    galleryPictures?: IOfferGallery | null;
    propertyGalleryPictures?: IPropertyGallery | null;
    constructionGalleryPictures?: IConstructionGalleryResponse | null;
    isAuthenticated: boolean;
}

export const useTrackAmplitudeOpenGallery = (params: UseTrackAmplitudeOpenGalleryParams): void => {
    const {
        isOpen,
        modalState,
        location,
        galleryFetchState,
        propertyGalleryFetchState,
        constructionFetchState,
        offer,
        property,
        galleryPictures,
        propertyGalleryPictures,
        constructionGalleryPictures,
        isAuthenticated
    } = params;

    const isFirstTabRef = useRef(true);

    useEffect(() => {
        if (!isOpen) {
            isFirstTabRef.current = true;
            return;
        }

        const isCurrentTabLoading = (() => {
            switch (modalState) {
                case OfferModalActiveTab.GALLERY: {
                    const isGalleryLoading = galleryFetchState === RequestState.None || galleryFetchState === RequestState.Waiting;
                    const isPropertyGalleryLoading =
                        !!property?.id && (propertyGalleryFetchState === RequestState.None || propertyGalleryFetchState === RequestState.Waiting);
                    return isGalleryLoading || isPropertyGalleryLoading;
                }
                case OfferModalActiveTab.CONSTRUCTION_GALLERY:
                    return constructionFetchState === RequestState.None || constructionFetchState === RequestState.Waiting;
                default:
                    return false;
            }
        })();

        if (isCurrentTabLoading) {
            return;
        }

        const navigation = isFirstTabRef.current ? "initial" : "tab_switch";

        const amplitudeTrackingPayload = getOpenGalleryAmplitudePayload({
            modalState,
            mediaTabNavigation: navigation,
            location,
            offerId: offer.id,
            propertyId: property?.id,
            galleryPictures,
            propertyGalleryPictures,
            constructionGalleryPictures,
            isAuthenticated
        });

        if (amplitudeTrackingPayload) {
            isFirstTabRef.current = false;
            trackAmplitudeOpenGallery(amplitudeTrackingPayload);
        }
    }, [modalState, isOpen, galleryFetchState, propertyGalleryFetchState, constructionFetchState]);
};
import {useEffect, useRef} from "react";

import {RequestState} from "@pg-mono/hooks";

import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {IPropertyGallery} from "../../../property/types/IPropertyGallery";
import {IOfferGallery} from "../../detail/types/IOfferGallery";
import {IConstructionGalleryResponse} from "../../types/ConstructionGallery";
import {IOfferDetail} from "../../types/IOfferDetail";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";
import {getOpenGalleryAmplitudePayload} from "./get_open_gallery_amplitude_payload";
import {trackAmplitudeOpenGallery} from "./track_amplitude_open_gallery";

interface UseTrackAmplitudeOpenGalleryParams {
    isOpen: boolean;
    modalState: OfferModalActiveTab | null;
    location?: string;
    galleryFetchState: RequestState;
    propertyGalleryFetchState: RequestState;
    constructionFetchState: RequestState;
    offer: IPropertyDetailOffer | IOfferDetail;
    property?: IPropertyDetail;
    galleryPictures?: IOfferGallery | null;
    propertyGalleryPictures?: IPropertyGallery | null;
    constructionGalleryPictures?: IConstructionGalleryResponse | null;
    isAuthenticated: boolean;
}

export const useTrackAmplitudeOpenGallery = (params: UseTrackAmplitudeOpenGalleryParams): void => {
    const {
        isOpen,
        modalState,
        location,
        galleryFetchState,
        propertyGalleryFetchState,
        constructionFetchState,
        offer,
        property,
        galleryPictures,
        propertyGalleryPictures,
        constructionGalleryPictures,
        isAuthenticated
    } = params;

    const isFirstTabRef = useRef(true);

    useEffect(() => {
        if (!isOpen) {
            isFirstTabRef.current = true;
            return;
        }

        const isCurrentTabLoading = (() => {
            switch (modalState) {
                case OfferModalActiveTab.GALLERY: {
                    const isGalleryLoading = galleryFetchState === RequestState.None || galleryFetchState === RequestState.Waiting;
                    const isPropertyGalleryLoading =
                        !!property?.id && (propertyGalleryFetchState === RequestState.None || propertyGalleryFetchState === RequestState.Waiting);
                    return isGalleryLoading || isPropertyGalleryLoading;
                }
                case OfferModalActiveTab.CONSTRUCTION_GALLERY:
                    return constructionFetchState === RequestState.None || constructionFetchState === RequestState.Waiting;
                default:
                    return false;
            }
        })();

        if (isCurrentTabLoading) {
            return;
        }

        const navigation = isFirstTabRef.current ? "initial" : "tab_switch";

        const amplitudeTrackingPayload = getOpenGalleryAmplitudePayload({
            modalState,
            mediaTabNavigation: navigation,
            location,
            offerId: offer.id,
            propertyId: property?.id,
            galleryPictures,
            propertyGalleryPictures,
            constructionGalleryPictures,
            isAuthenticated
        });

        if (amplitudeTrackingPayload) {
            isFirstTabRef.current = false;
            trackAmplitudeOpenGallery(amplitudeTrackingPayload);
        }
    }, [modalState, isOpen, galleryFetchState, propertyGalleryFetchState, constructionFetchState]);
};
